<template lang="pug">
  div
    div.bg
      div.container
        header
          nav.navbar.is-transparent.has-shadow(aria-label="dropdown navigation")
            .navbar-brand
              router-link.navbar-logo(to='/')
                .crop
                    img(:src="ecoinventLogo", alt="ecoinvent", width="60px")
              a.navbar-burger.burger(
                @click="toggleBurger"
                :class="{'is-active': burgerActive}" role="button"
                aria-label="menu" aria-expanded="false" data-target="menu")
                span
                span
                span
            #menu.navbar-menu(:class="{'is-active': burgerActive}")
              .navbar-start
                .navbar-item.has-dropdown.is-hoverable
                  a.navbar-item(v-if="isAuthenticated" :href="userGuide")
                    b-icon(icon="file-pdf")
                    span.has-left-margin {{ $t('Documentation')}}
              .navbar-end
                .navbar-item.has-dropdown.is-hoverable(v-if="isAuthenticated")
                  a.navbar-link
                    | {{$t("Download Templates")}}
                    .navbar-dropdown
                      a.navbar-item(:href="datasetTemplate")
                        b-icon(icon="file-excel")
                        span.has-left-margin {{$t("Empty Dataset Template")}}
                      a.navbar-item(:href="umdTemplate")
                        b-icon(icon="file-excel")
                        span.has-left-margin {{$t("Empty Master Data Template")}}
                      hr.navbar-divider
                      download-master-data.navbar-item
                        b-tooltip(:label="$t('Uploading this file results in a long validation time. Copy, paste, and change entries from this file in an empty User Master Data Template.')" multilined)
                          b-icon(icon="file-alt")
                          span.has-left-margin {{$t("Complete Master Data")}}
                .navbar-item(v-if="isAuthenticated")
                  .field.is-grouped
                    p.control
                      a.button(@click="doLogout")
                        span.icon
                          i.fas.fa-user
                        span Logout
    div.container
      div.is-size-7.is-pulled-right.logged-in-as(v-if="hasName")
        | {{ $t('Logged in as')}} {{ name }}
</template>

<script>
import DownloadMasterData from './DownloadMasterData'
import { logout } from '../utils/api'

export default {
  name: 'EcoinventHeader',
  components: { DownloadMasterData },
  mounted() {},
  props: {},
  data() {
    return {
      burgerActive: false,
      ecoinventLogo: require('../assets/ecoinvent Brand mark.png'),
      userGuide: require('../assets/User_documentation_-_Excel_to_ecoSpold2_Web_Converter_v1.pdf'),
      datasetTemplate: require('../assets/dataset_template.xlsx'),
      umdTemplate: require('../assets/umd_template.xlsx')
    }
  },
  computed: {
    hasName() {
      return this.isAuthenticated && !!this.name
    },
    name() {
      return this.$store.getters.name
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated
    }
  },
  methods: {
    toggleBurger() {
      this.burgerActive = !this.burgerActive
    },
    doLogout() {
      logout()
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
  div.bg {
    background-image: linear-gradient(to top, #e01a1a, #eb6666);
  }
  nav {
    background-image: linear-gradient(to top, #e01a1a, #eb6666);
  }

  .navbar-logo {
    padding: 0.5rem 2rem 0.2rem 1rem;
  }

  .crop {
    width: 60px;
    height: 4.9rem;
  }

  .crop img {
    width: 60px;
    /* margin: -1.2rem 0 0 0; */
  }

  .has-left-margin {
    margin-left: 0.5rem;
  }

  .is-next-line {
    display: block;
  }

  .logged-in-as {
    padding-top: 0.25rem;
    padding-right: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/EcoinventHeader.vue